import React from 'react';
import withAnalyticsEvents from '@atlaskit/analytics-next/withAnalyticsEvents';
export const WithCreateAnalyticsEvent = withAnalyticsEvents()(class WithCreateAnalyticsEvent extends React.Component {
  render() {
    const {
      render,
      createAnalyticsEvent
    } = this.props;
    return render(createAnalyticsEvent);
  }
});